module.exports = __webpack_public_path__ + "static/media/turin-10.7c18636c.jpg";